export const gender = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
  { name: 'Others', value: 'other' },
];

export const authorSpecialty = [
  { id: 1, value: 'Cardiovascular Radiology' },
  { id: 2, value: 'Chest Radiology' },
  { id: 3, value: 'Emergency Radiology' },
  { id: 4, value: 'Gastrointestinal (GT) Radiology' },
  { id: 5, value: 'Genitourinary (GU) Radiology' },
  { id: 6, value: 'Head and Neck Radiology' },
  { id: 7, value: 'Musculoskeletal Radiology' },
  { id: 8, value: 'Neuroradiology' },
  { id: 9, value: 'Neuro-Interventional Radiology' },
  { id: 10, value: 'Pediatric Radiology' },
  { id: 11, value: 'Resident' },
  { id: 12, value: 'Interventional Radiology' },
  { id: 13, value: 'Nuclear Radiology' },
  { id: 14, value: 'Radiation Oncology' },
];

export const modalityList = ['CT', 'Fluoroscopy', 'MRI', 'Nuclear Medicine', 'PET/CT', 'PET/MR', 'Radiograph', 'SPECT-CT', 'Ultrasound'];

export const differentialDiagnosis = [
  { id: 1, value: 'Vascular' },
  { id: 2, value: 'Infection/Inflammation' },
  { id: 3, value: 'Neoplasm' },
  { id: 4, value: 'Drugs/Toxins' },
  { id: 5, value: 'Degenerative' },
  { id: 6, value: 'Iatrogenic' },
  { id: 7, value: 'Idiopathic' },
  { id: 8, value: 'Congenital/Inherited/developmental' },
  { id: 9, value: 'Autoimmune' },
  { id: 10, value: 'Allergic' },
  { id: 11, value: 'Anatomic' },
  { id: 12, value: 'Endocrine' },
  { id: 13, value: 'Metabolic' },
  { id: 14, value: 'Environmental/Work exposure' },
];

export const userSpecialty = [
  { id: 1, value: 'Allergy and Immunology' },
  { id: 2, value: 'Anesthesiology' },
  { id: 3, value: 'Breast Surgery' },
  { id: 4, value: 'Body IR' },
  { id: 5, value: 'Cardiothoracic surgery' },
  { id: 6, value: 'Colorectal Surgery' },
  { id: 7, value: 'Dermatology' },
  { id: 8, value: 'Emergency Medicine' },
  { id: 9, value: 'ENT' },
  { id: 10, value: 'Endocrine Surgery' },
  { id: 11, value: 'Family Medicine' },
  { id: 12, value: 'General surgery' },
  { id: 13, value: 'Hepatobiliary Surgery ' },
  { id: 14, value: 'Internal Medicine' },
  { id: 15, value: 'Neurology' },
  { id: 16, value: 'Neurosurgery' },
  { id: 17, value: 'Neuro IR' },
  { id: 18, value: 'OB/GYN' },
  { id: 19, value: 'Ophthalmology' },
  { id: 20, value: 'Orthopedic Surgery' },
  { id: 21, value: 'Oral and Maxillofacial Surgery' },
  { id: 22, value: 'Plastic Surgery' },
  { id: 23, value: 'PM&R' },
  { id: 24, value: 'Surgical oncology' },
  { id: 25, value: 'Transplant Surgery' },
  { id: 26, value: 'Trauma surgery' },
  { id: 27, value: 'Vascular surgery' },
  { id: 28, value: 'Vascular IR' },
  { id: 29, value: 'Urology' },
];
